import { getBackend } from '@/backend';
import type { BackendClients, ProjectWriteClient } from '@/backend/contracts';

import type { ProjectWriteOperation, ProjectWriteResult } from './write-operation';

export type ApplyProjectWritesRequest = {
    orgId: string;
    projectId: string;
    operations: ProjectWriteOperation[];
};

export type ApplyProjectWritesResponse = {
    results: ProjectWriteResult[];
};

export type ResolveProjectWriteConflictAction =
    | 'apply_proposed'
    | 'keep_shared'
    | 'dismiss';

export type ResolveProjectWriteConflictRequest = {
    orgId: string;
    projectId: string;
    conflictId: string;
    action: ResolveProjectWriteConflictAction;
    operation?: ProjectWriteOperation;
    conflictReason?: string;
};

export type ResolveProjectWriteConflictResponse = {
    result: ProjectWriteResult;
};

type ProjectWriteBackend = Pick<BackendClients, 'projectWrites'>;

function requireProjectWriteClient(clients: ProjectWriteBackend): ProjectWriteClient {
    if (!clients.projectWrites) {
        throw new Error('Project write backend client is not configured');
    }

    return clients.projectWrites;
}

export async function sendProjectWriteBatchToAuthority(
    request: ApplyProjectWritesRequest,
    clients: ProjectWriteBackend = getBackend(),
): Promise<ApplyProjectWritesResponse> {
    return requireProjectWriteClient(clients).applyProjectWrites(request);
}

/** @deprecated Use sendProjectWriteBatchToAuthority for authority batch writes. */
export const applyProjectWrites = sendProjectWriteBatchToAuthority;

export async function resolveProjectWriteConflict(
    request: ResolveProjectWriteConflictRequest,
    clients: ProjectWriteBackend = getBackend(),
): Promise<ResolveProjectWriteConflictResponse> {
    return requireProjectWriteClient(clients).resolveProjectWriteConflict(request);
}
